import * as React from "react";
import ContentDisplayComponent from "../../content/ContentDisplayComponent";
import { CategoryInterface } from "../../../interfaces/CategoryInterface";
import FilterValueContentComponent from "./FilterValueContentComponent";

interface State {
  category?: CategoryInterface;
}

const FArticleHeaderComponent: React.FC<State> = React.memo(({ category }) => {
  return (
    <>
      {category && (
        <>
          <ContentDisplayComponent content={category.content} />
          <FilterValueContentComponent category={category} />
        </>
      )}
    </>
  );
});

export default FArticleHeaderComponent;
